// fetches a remote URL and extracts it to a File
export const urlToAudioFile = async (url: string, userFileName?: string): Promise<File> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch audio: ${response.statusText}`);
  }

  const arrayBuffer = await response.arrayBuffer();
  const fileName = userFileName || url.split("/").pop() || "audio.mp3";

  // default to mpeg
  const mimeType = response.headers.get("content-type") || "audio/mpeg";

  return new File([arrayBuffer], fileName, { type: mimeType });
};
